export enum EnumStatusProcessoTipo {
    AguardandoInicio = 1,
    EmProducao = 2,
    Finalizado = 3,
    Cancelado = 6,
    AguardandoRetirada = 9,
    EmEntrega = 10
}